function offcanvasAsideShow(identifier: string, overlay: string) {
  let element1 = document.getElementById(identifier)
  let element2 = document.getElementById(overlay)

  element1?.classList.add('drawer', 'drawer-start', 'drawer-on')
  element2?.classList.add('drawer-overlay')
}

function offcanvasAsideHide(identifier: string, overlay: string) {
  let element1 = document.getElementById(identifier)
  let element2 = document.getElementById(overlay)

  element1?.classList.remove('drawer', 'drawer-start', 'drawer-on')
  element2?.classList.remove('drawer-overlay')
}

function offcanvasShow(button: string, container: string, overlay: string) {
  let element1 = document.getElementById(button)
  let element2 = document.getElementById(container)
  let element3 = document.getElementById(overlay)

  element1?.classList.add('active')
  element2?.classList.add('drawer-on')
  element3?.classList.add('drawer-overlay')
}

function offcanvasHide(button: string, container: string, overlay: string) {
  let element1 = document.getElementById(button)
  let element2 = document.getElementById(container)
  let element3 = document.getElementById(overlay)

  element1?.classList.remove('active')
  element2?.classList.remove('drawer-on')
  element3?.classList.remove('drawer-overlay')
}

export { offcanvasAsideShow, offcanvasAsideHide, offcanvasShow, offcanvasHide }
